// extracted by mini-css-extract-plugin
module.exports = {"thumbs":"videoThumbs-module--thumbs--3U3b2"};